// Sistema de IA diferenciado por oponente
export const OpponentAI = {
  novice: {
    name: 'NOVICIO',
    speed: { min: 0.005, max: 0.010 },
    attackInterval: { min: 4000, max: 6000 },
    attackChance: 0.25,
    blockChance: 0.15,
    blockReactionTime: 1500,
    comboChance: 0,
    dodgeChance: 0.1,
    aggressiveness: 0.3,
    patterns: ['simple-punch', 'simple-kick'],
    health: 80,
    damage: { hand: 8, foot: 12 },
    imgFolder: 'novice'
  },
  
  boosabon: {
    name: 'BOOSABON',
    speed: { min: 0.010, max: 0.018 },
    attackInterval: { min: 3000, max: 5000 },
    attackChance: 0.35,
    blockChance: 0.25,
    blockReactionTime: 1200,
    comboChance: 0.15,
    dodgeChance: 0.2,
    aggressiveness: 0.5,
    patterns: ['simple-punch', 'simple-kick', 'double-punch'],
    health: 100,
    damage: { hand: 10, foot: 15 },
    imgFolder: 'boosabon'
  },
  
  sabon: {
    name: 'SABON',
    speed: { min: 0.015, max: 0.022 },
    attackInterval: { min: 2500, max: 4000 },
    attackChance: 0.45,
    blockChance: 0.35,
    blockReactionTime: 1000,
    comboChance: 0.25,
    dodgeChance: 0.3,
    aggressiveness: 0.6,
    patterns: ['simple-punch', 'simple-kick', 'double-punch', 'high-kick'],
    health: 120,
    damage: { hand: 12, foot: 18 },
    imgFolder: 'sabon'
  },
  
  'sabon-nim': {
    name: 'SABON NIM',
    speed: { min: 0.018, max: 0.025 },
    attackInterval: { min: 2000, max: 3500 },
    attackChance: 0.55,
    blockChance: 0.45,
    blockReactionTime: 800,
    comboChance: 0.35,
    dodgeChance: 0.4,
    aggressiveness: 0.7,
    patterns: ['simple-punch', 'double-punch', 'high-kick', 'spinning-kick', 'combo-3'],
    health: 140,
    damage: { hand: 14, foot: 21 },
    imgFolder: 'sobonnim'
  },
  
  champion: {
    name: 'CAMPEÓN',
    speed: { min: 0.020, max: 0.028 },
    attackInterval: { min: 1800, max: 3000 },
    attackChance: 0.65,
    blockChance: 0.55,
    blockReactionTime: 600,
    comboChance: 0.45,
    dodgeChance: 0.5,
    aggressiveness: 0.8,
    patterns: ['double-punch', 'high-kick', 'spinning-kick', 'combo-3', 'feint-attack'],
    health: 160,
    damage: { hand: 16, foot: 24 },
    imgFolder: 'champion'
  },
  
  master: {
    name: 'MASTER',
    speed: { min: 0.022, max: 0.032 },
    attackInterval: { min: 1500, max: 2500 },
    attackChance: 0.75,
    blockChance: 0.65,
    blockReactionTime: 400,
    comboChance: 0.60,
    dodgeChance: 0.6,
    aggressiveness: 0.9,
    patterns: ['double-punch', 'high-kick', 'spinning-kick', 'combo-3', 'combo-4', 'feint-attack', 'counter-attack'],
    health: 180,
    damage: { hand: 18, foot: 27 },
    imgFolder: 'master'
  },
  
  grandmaster: {
    name: 'GRAN MASTER',
    speed: { min: 0.025, max: 0.035 },
    attackInterval: { min: 1200, max: 2000 },
    attackChance: 0.85,
    blockChance: 0.75,
    blockReactionTime: 300,
    comboChance: 0.75,
    dodgeChance: 0.7,
    aggressiveness: 1.0,
    patterns: ['double-punch', 'spinning-kick', 'combo-3', 'combo-4', 'combo-5', 'feint-attack', 'counter-attack', 'perfect-timing'],
    health: 200,
    damage: { hand: 20, foot: 30 },
    imgFolder: 'gran master'
  }
};

// Sistema de comportamiento inteligente
export class OpponentBehavior {
  constructor(opponentId) {
    this.config = OpponentAI[opponentId] || OpponentAI.novice;
    this.lastAttackTime = 0;
    this.isInCombo = false;
    this.comboCount = 0;
    this.playerLastHitTime = 0;
    this.consecutivePlayerHits = 0;
  }

  // Calcular velocidad de movimiento
  getMovementSpeed() {
    const { min, max } = this.config.speed;
    return min + Math.random() * (max - min);
  }

  // Decidir si debe atacar
  shouldAttack(currentTime) {
    const timeSinceLastAttack = currentTime - this.lastAttackTime;
    const { min, max } = this.config.attackInterval;
    const minInterval = min + Math.random() * (max - min);
    
    if (timeSinceLastAttack < minInterval) return false;
    
    return Math.random() < this.config.attackChance;
  }

  // Decidir si debe bloquear (reacciona a golpes del jugador)
  shouldBlock(playerIsAttacking, currentTime) {
    if (!playerIsAttacking) return false;
    
    // Reacción basada en tiempo
    const reactionDelay = this.config.blockReactionTime;
    const timeSincePlayerAttack = currentTime - this.playerLastHitTime;
    
    if (timeSincePlayerAttack > reactionDelay) return false;
    
    return Math.random() < this.config.blockChance;
  }

  // Decidir si debe esquivar
  shouldDodge() {
    return Math.random() < this.config.dodgeChance;
  }

  // Decidir si debe hacer combo
  shouldCombo() {
    if (this.isInCombo) return true;
    return Math.random() < this.config.comboChance;
  }

  // Seleccionar tipo de ataque
  selectAttackType() {
    const patterns = this.config.patterns;
    return patterns[Math.floor(Math.random() * patterns.length)];
  }

  // Actualizar estado después de ataque
  onAttack(currentTime) {
    this.lastAttackTime = currentTime;
    
    if (this.shouldCombo()) {
      this.isInCombo = true;
      this.comboCount++;
    } else {
      this.isInCombo = false;
      this.comboCount = 0;
    }
  }

  // Registrar golpe del jugador
  onPlayerHit(currentTime) {
    this.playerLastHitTime = currentTime;
    this.consecutivePlayerHits++;
    
    // Si recibe muchos golpes, aumenta agresividad temporalmente
    if (this.consecutivePlayerHits > 3) {
      this.config.attackChance = Math.min(0.95, this.config.attackChance + 0.1);
      this.config.aggressiveness = Math.min(1.0, this.config.aggressiveness + 0.1);
    }
  }

  // Resetear contador de golpes
  resetPlayerHitCounter() {
    this.consecutivePlayerHits = 0;
  }

  // Obtener nivel de agresividad
  getAggressiveness() {
    return this.config.aggressiveness;
  }

  // Obtener salud inicial
  getInitialHealth() {
    return this.config.health;
  }

  // Obtener daño de ataque
  getDamage(attackType) {
    return this.config.damage[attackType] || 10;
  }

  // Obtener carpeta de imágenes
  getImageFolder() {
    return this.config.imgFolder;
  }
}
